export default __webpack_public_path__ + "static/media/boo-thinking.febcf230.png";